import React from "react";

export const LogoMark = ({ size = 34 }) => (
  <img
    src="/logo-cyan.png"
    alt="DestinyCS"
    width={size * 2}
    height={size}
    data-testid="logo-mark"
    className="object-contain"
    style={{ height: size, width: "auto" }}
  />
);

export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-2.5" data-testid="logo">
    <LogoMark size={compact ? 24 : 30} />
    {!compact && (
      <div className="leading-none">
        <span className="font-display font-800 font-extrabold text-lg tracking-tight text-white">
          Destiny<span className="text-cyan-400">CS</span>
        </span>
        <span className="block font-mono-tech text-[9px] tracking-[0.3em] text-slate-500 mt-0.5">
          GEOSPATIAL INTELLIGENCE
        </span>
      </div>
    )}
  </div>
);
